import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f30eb8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade google-modal",
  ref: "dataSourceLegend",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = { class: "h5 me-2" }
const _hoisted_7 = { class: "fst-italic" }
const _hoisted_8 = { class: "map-container" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "street",
  class: "map-type"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "map",
  class: "map-type",
  hidden: ""
}, null, -1))
const _hoisted_11 = { id: "toggleStreetView" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}, "Close", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdowns = _resolveComponent("Dropdowns")!
  const _component_ModalBody = _resolveComponent("ModalBody")!
  const _component_ModalFooter = _resolveComponent("ModalFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, "Comp " + _toDisplayString(_ctx.details.compNumber), 1),
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.details.address.address1), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.details.address.city) + ", " + _toDisplayString(_ctx.details.address.state) + " " + _toDisplayString(_ctx.details.address.zipCode), 1)
          ])
        ]),
        _createVNode(_component_ModalBody, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  id: "toggleButton",
                  class: "btn btn-google-dark",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleView()))
                }, "Satellite View")
              ])
            ]),
            _createVNode(_component_Dropdowns, { onCallback: _ctx.DropdownsCallback }, null, 8, ["onCallback"])
          ]),
          _: 1
        }),
        _createVNode(_component_ModalFooter, null, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args)))
            }, "Save"),
            _hoisted_12
          ]),
          _: 1
        })
      ])
    ])
  ], 512))
}